import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { debounce } from 'lodash';
import {
    Avatar,
    Breadcrumb,
    Button,
    Col,
    Input,
    Modal,
    Row,
    Select,
    Switch,
    Table,
    Tabs,
    Tooltip,
    message,
    List
} from 'antd';
import { ApartmentOutlined, DeleteOutlined, EditOutlined, PlusOutlined, SearchOutlined, ShoppingOutlined } from '@ant-design/icons';
import { SetRoute } from '../scripts/action';
import { CheckPermission } from '../scripts/helpers';
import { Constants, Permissions } from '../scripts/settings';
import API from '../scripts/api';
import Resources from '../scripts/resources';
import PaginationInfo from '../components/PaginationInfo';
import CategoryForm from '../forms/Category';

class Category extends Component {
    constructor() {
        super();

        this.state = {
            activeTab: 'main',
            mainCats: [],
            mainPagination: {
                total: 0,
                current: 1,
                pageSize: Constants.pageSize,
                size: 'small'
            },
            subCats: [],
            subPagination: {
                total: 0,
                current: 1,
                pageSize: Constants.pageSize,
                size: 'small'
            }
        };

        this.formRef = React.createRef();
        this.subRef = React.createRef();

        this.handleMainSearch = debounce(this.handleMainSearch, 500);
        this.handleSubSearch = debounce(this.handleSubSearch, 1000);
    }

    fetch = (params = {}, subMode) => {
        this.setState({ loading: true, });

        params.type = subMode ? 'sub' : 'main';

        API.category.list(params)
            .then((result) => {
                if (subMode) {
                    if (result.data) {
                        this.setState({
                            loading: false,
                            subCats: result.data,
                            subPagination: {
                                ...this.state.subPagination, ...{
                                    current: result.current_page,
                                    pageSize: result.per_page,
                                    total: result.total
                                }
                            }
                        });
                    } else {
                        this.setState({ loading: false });
                    }
                } else {
                    this.setState({
                        loading: false,
                        mainCats: result.data,
                        mainPagination: {
                            ...this.state.mainPagination, ...{
                                current: result.current_page,
                                pageSize: result.per_page,
                                total: result.total
                            }
                        }
                    });
                }
            })
            .catch(() => {
                this.setState({ loading: false });
            });
    }

    showModal = (category = {}, subMode) => {
        category.subCategory = category.subCategory || this.state.parentId;

        this.setState({ visible: true, selected: category });

        setTimeout(() => {
            this.formRef.current.handleDidMount(category, subMode);
        }, 0);
    }

    hideModal = () => {
        this.setState({ visible: false });

        setTimeout(() => {
            this.formRef.current.handleWillUnmount();
        }, 0);
    }

    handleProducts = (record) => {
        this.props.history.push(`/products/${record.subCategory}/${record.id}`);
    }

    handleChange = (tab) => {
        if (!this.state.loading){
            this.setState({ activeTab: tab });
            if (tab == "main"){
                this.fetch({ page: 1, q: this.state.subSearch });
            }
        }
    }

    handleMainFilter = (catId) => {
        if (this.state.parentId !== catId) this.fetch({ page: 1, parentId: catId }, true);

        this.setState({ activeTab: 'sub', parentId: catId });
    }

    handleSubFilter = (value) => {
        this.setState({ parentId: value });
        this.fetch({ page: 1, q: this.state.subSearch, parentId: value }, true);
    }

    handleMainSearch = (value) => {
        this.setState({ mainSearch: value });
        this.fetch({ page: 1, q: value, parentId: value });

    }

    handleSubSearch = (value) => {
        this.setState({ subSearch: value });
        this.fetch({ page: 1, q: value, parentId: this.state.parentId }, true);
    }

    handleMainTableChange = (pagination) => {
        this.setState({
            mainPagination: { ...this.state.mainPagination, ...{ current: pagination.current } }
        });

        this.fetch({ page: pagination.current });

    }

    handleSubTableChange = (pagination) => {
        this.setState({
            subPagination: { ...this.state.subPagination, ...{ current: pagination.current } }
        });

        this.fetch({ page: pagination.current, parentId: this.state.parentId, q: this.state.subSearch }, true);
    }

    handleStatus = (record, subMode) => {
        Modal.confirm({
            title: record.status ? Resources.confirmCatDeactivate : Resources.confirmCatActivate,
            okText: Resources.yes,
            okType: record.status ? 'danger' : 'primary',
            cancelText: Resources.no,
            onOk: () => {
                this.setState({ loading: true });

                API.category.statusUpdate(record)
                    .then((result) => {
                        message.success(result.message);

                        const { mainSearch, parentId, subPagination, subSearch, mainPagination } = this.state;

                        if (subMode)
                            this.fetch({ page: subPagination.current, parentId: parentId, q: subSearch }, true);
                        else
                            this.fetch({ page: mainPagination.current, q: mainSearch });
                    })
                    .catch(() => {
                        this.setState({ loading: false });
                    });
            }
        });
    }

    handleDelete = (record, subMode) => {
        Modal.confirm({
            title: Resources.confirmDeleteCat,
            okText: Resources.yes,
            okType: 'danger',
            cancelText: Resources.no,
            onOk: () => {
                this.setState({ loading: true });

                API.category.delete(record)
                    .then((result) => {
                        message.success(result.message);

                        const { mainSearch, parentId, subPagination, subSearch, mainPagination } = this.state;

                        if (subMode)
                            this.fetch({ page: subPagination.current, parentId: parentId, q: subSearch }, true);
                        else
                            this.fetch({ page: mainPagination.current, q: mainSearch });
                    })
                    .catch(() => {
                        this.setState({ loading: false });
                    });
            }
        });
    }

    handleSubmit = (values) => {
        const { activeTab, mainSearch, parentId, selected, subPagination, subSearch } = this.state;
        const action = selected._id ? API.category.update : API.category.add;

        values.path = values.name
        values.category_type = "bazaar"
        this.setState({ submitting: true });
        if (activeTab === 'main'){
            values.isParent = true
            values.layer = 1
        }else{
            values.isParent = false
            values.layer = 2
        }


        action(values, selected._id)
            .then((result) => {
                message.success(result.message);
                this.setState({ submitting: false });
                this.hideModal();

                if (activeTab === 'main')
                    this.fetch({ q: mainSearch });
                else
                    this.fetch({ page: subPagination.current, parentId: parentId, q: subSearch }, true);
            })
            .catch(() => {
                this.setState({ submitting: false });
            });
    }

    componentDidMount() {
        const { onSetRoute, routeName, parentName } = this.props;

        onSetRoute({ openKey: parentName, selectedKey: routeName });

        this.fetch();
    }

    render() {
        const { activeTab, loading, mainCats, mainPagination, mainSearch, parentId, subCats, submitting, subPagination, visible } = this.state;
        const { permissions } = this.props;
        const mainCategories = mainSearch ? mainCats.filter(o => o.name.indexOf(mainSearch) >= 0) : mainCats;

        const mainColumns = [{
            title: Resources.title,
            dataIndex: 'name'
        }, 
       
        {
            title: Resources.image,
            dataIndex: 'id_store',
            className: 'col-center col-avatar',
            render: val => val ? <Tooltip title={<Avatar src={`${Constants.imagePathCategory}${val.location}`} shape="square" size={140} />}><Avatar src={`${Constants.imagePathCategory}${val.location}`} shape="square" size="small" /></Tooltip> : <Avatar shape="square" size="small" />
        }, {
            title: Resources.status,
            dataIndex: 'status',
            className: 'col-center',
            render: (val, record) => <Switch size="small" checked={(val=== true)} onClick={() => this.handleStatus(record)}  />
        }];

        const subColumns = [{
            title: Resources.title,
            dataIndex: 'name'
        }, 
       
        {
            title: Resources.image,
            dataIndex: 'id_store',
            className: 'col-center col-avatar',
            render: val => val ? <Tooltip title={<Avatar src={`${Constants.imagePathCategory}${val.location}`} shape="square" size={140} />}><Avatar src={`${Constants.imagePathCategory}${val.location}`} shape="square" size="small" /></Tooltip> : <Avatar shape="square" size="small" />
        }, {
            title: Resources.status,
            dataIndex: 'status',
            className: 'col-center',
            render: (val, record) => <Switch size="small" checked={(val === true)} onClick={() => this.handleStatus(record, true)}  />
        }];

        // if (permissions.action) {
            mainColumns.push({
                title: Resources.action,
                dataIndex: 'id',
                className: 'col-center',
                render: (val, record) => (
                    <Fragment>
                        {/*<Tooltip title={Resources.subCats}>*/}
                        {/*    <Button type="link" icon={<ApartmentOutlined />} onClick={() => this.handleMainFilter(val)} />*/}
                        {/*</Tooltip>*/}
                        <Tooltip title={Resources.edit}>
                            <Button type="link" icon={<EditOutlined />} onClick={() => this.showModal(record)} />
                        </Tooltip>
                        <Tooltip title={Resources.delete}>
                            <Button type="link" icon={<DeleteOutlined />} onClick={() => this.handleDelete(record)} />
                        </Tooltip>
                    </Fragment>
                )
            });

            subColumns.push({
                title: Resources.action,
                dataIndex: 'id',
                className: 'col-center',
                render: (val, record) => (
                    <Fragment>
                        {/*<Tooltip title={Resources.products}>*/}
                        {/*    <Button type="link" icon={<ShoppingOutlined />} onClick={() => this.handleProducts(record)} />*/}
                        {/*</Tooltip>*/}
                        <Tooltip title={Resources.edit}>
                            <Button type="link" icon={<EditOutlined />} onClick={() => this.showModal(record, true)} />
                        </Tooltip>
                        <Tooltip title={Resources.delete}>
                            <Button type="link" icon={<DeleteOutlined />} onClick={() => this.handleDelete(record, true)} />
                        </Tooltip>
                    </Fragment>
                )
            });
        // }

        return (
            <Fragment>
                <Breadcrumb>
                    <Breadcrumb.Item>{Resources.category}  </Breadcrumb.Item>
                </Breadcrumb>
                <div className="ant-content">
                    <Tabs activeKey={activeTab} type="card" onTabClick={this.handleChange}>
                        <Tabs.TabPane tab={`${Resources.category} ${Resources.main}`} key="main">
                            <Row gutter={24} style={{ marginBottom: 16 }}>
                                <Col xs={24} md={4}>
                                    <Button type="primary" icon={<PlusOutlined />} onClick={() => this.showModal()} block>{Resources.add}</Button>
                                </Col>
                                <Col xs={24} md={{ span: 6, offset: permissions.add ? 14 : 18 }}>
                                    <Tooltip title={Resources.searchHintCategory}>
                                        <Input
                                            type="text"
                                            prefix={<SearchOutlined />}
                                            placeholder={Resources.search}
                                            onChange={({ target: { value } }) => this.handleMainSearch(value)}
                                            allowClear
                                        />
                                    </Tooltip>
                                </Col>
                            </Row>
                            <Table
                                columns={mainColumns}
                                dataSource={mainCategories}
                                loading={loading}
                                onChange={this.handleMainTableChange}
                                pagination={mainPagination}
                                size="small"
                                rowKey="id"
                                scroll={{ x: 600 }}
                            />
                            {!!mainPagination.total && <PaginationInfo current={mainPagination.current} pageSize={mainPagination.pageSize} total={mainPagination.total} style={{ bottom: 0, right: 0 }} />}
                        </Tabs.TabPane>
                        <Tabs.TabPane tab={`${Resources.category} ${Resources.sub}`} key="sub">
                            <Row gutter={24} style={{ marginBottom: 16 }}>
                                 <Col xs={24} md={4}>
                                    <Button type="primary" icon={<PlusOutlined />} onClick={() => this.showModal({}, true)} block>{Resources.add}</Button>
                                </Col>
                                <Col xs={24} md={{ span: 6, offset: permissions.add ? 8 : 12 }}>
                                    <Select
                                        filterOption
                                        onChange={this.handleSubFilter}
                                        placeholder={Resources.filterByMainCat}
                                        value={parentId}
                                        optionFilterProp="name"
                                        style={{ display: 'block' }}
                                        allowClear
                                        showSearch>
                                        {mainCats.map(cat => <Select.Option key={cat._id} value={cat._id} name={cat.name}>{cat.name}</Select.Option>)}
                                    </Select>
                                </Col>
                                {/*<Col xs={24} md={6}>*/}
                                {/*    <Tooltip title={Resources.searchHintCategory}>*/}
                                {/*        <Input*/}
                                {/*            type="text"*/}
                                {/*            prefix={<SearchOutlined />}*/}
                                {/*            placeholder={Resources.search}*/}
                                {/*            onChange={({ target: { value } }) => this.handleSubSearch(value)}*/}
                                {/*            allowClear*/}
                                {/*        />*/}
                                {/*    </Tooltip>*/}
                                {/*</Col>*/}
                            </Row>
                            <Table
                                columns={subColumns}
                                dataSource={subCats}
                                loading={loading}
                                onChange={this.handleSubTableChange}
                                pagination={subPagination}
                                size="small"
                                rowKey="id"
                                scroll={{ x: 600 }}
                            />
                            {!!subPagination.total && <PaginationInfo current={subPagination.current} pageSize={subPagination.pageSize} total={subPagination.total} style={{ bottom: 0, right: 0 }} />}
                        </Tabs.TabPane>
                    </Tabs>
                </div>
                <CategoryForm ref={this.formRef} mainCats={mainCats} onCancel={this.hideModal} onSubmit={this.handleSubmit} submitting={submitting} visible={visible} />
            </Fragment>
        );
    }
};

export default connect(
    (state) => {
        return {
            permissions: {
                action: CheckPermission(state.app.user, Permissions.category_option),
                add: CheckPermission(state.app.user, Permissions.category_store)
            }
        };
    },
    (dispatch) => {
        return {
            onSetRoute: (data) => dispatch(SetRoute(data))
        };
    }
)(Category);